// extracted by mini-css-extract-plugin
export default {"subs":"Subscribe_subs__iJLsq","form_block":"Subscribe_form_block__YT1Pq","content":"Subscribe_content__SRNLx"};